import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import * as theme from '../../../theme';
import TruCard from "../../TruCard";
import ListItem from '../items/ListItem';
import { sortPeople } from "../../../functions/Sorting";

export default function PreScanFormsList(props) {
  const [preScanFormsOnDisplay, setPreScanFormsOnDisplay] = useState(sortPeople([]));
  const navigate = useNavigate();

  useEffect(() => {
    if (props && props.preScanFormsList != null) {
      setPreScanFormsOnDisplay(sortPeople(props.preScanFormsList));
    }
  }, [props.preScanFormsList])

  return (
    <TruCard title={'Pre-Scan Forms'}>
      <div style={theme.Container.listColumn}>
        {preScanFormsOnDisplay != null && preScanFormsOnDisplay.map(p => {
          return (
            <ListItem 
              key={p.id}
              label={p.lastName + ', ' + p.firstName}
              content={p.email}
              onClick={() => navigate(`/prescan-forms/${p.id}`)}
            />
          )
        })}
      </div>
    </TruCard>
  );
}